export enum ResourceAutoAssignmentPrioritizationValues {
  Random = 1,
  Alphabetical,
  ResourcesSortOrder,
  RoundRobin,
}
